<template>
  <slider-layout></slider-layout>
</template>
<script>
  import SliderLayout from './Layout/SliderLayout.vue'
  
  export default {
    components: {
      SliderLayout,
    }
  }
</script>
<style scoped>
</style>
